const resolve = (resolves, ...args) => {
  return new Promise((resolve, reject) => {
    const values = Object.keys(resolves).map((key) =>
      typeof resolves[key] === 'function'
        ? resolves[key](...args)
        : resolves[key]
    );
    Promise.all(values)
      .then((resolvedValues) => {
        resolve(
          Object.keys(resolves).reduce((obj, key, index) => {
            return Object.assign({}, obj, { [key]: resolvedValues[index] });
          }, {})
        );
      })
      .catch(reject);
  });
};

export { resolve };
